import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import EnterPin from "../2FA/EnterPin";
import SetPin from "../2FA/SetPin";
import { ForgotPassword } from "../ForgotPassword/ForgotPassword";
import { Login } from "../Login/login";
import LoginWithOTP from "../Login/loginWithOTP";
import TOTP from "../TOTP";
import { alertActions } from "../_actions";
import { history } from "../_helpers";
import getCookie, { getUrlParamValue } from "../_helpers/cookies";
import { loginTypeActions } from "../_reducers/logintype.reducer";

function App(props) {
  const { dispatch, alert } = props;

  useEffect(() => {
    if (getUrlParamValue("linkApp") && atob(getUrlParamValue("linkApp")) === "y") {
      getMobileOS();
    } else {
      loginTypeActions.updateVendor(
        getCookie("url_params")?.indexOf("vendor") > -1 ? true : false
      );
    }
  }, []);

  history.listen((location, action) => {
    // clear alert on location change
    dispatch(alertActions.clear());
  });

  function getMobileOS() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/android/i.test(userAgent)) {
      window.location.href = `intent://${atob(getUrlParamValue("route"))}/#Intent;scheme=${atob(getUrlParamValue("scheme"))};package=in.tradebulls.trading;S.browser_fallback_url=${getUrlParamValue("fallbackUrl")};end`;
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.replace(`${atob(getUrlParamValue("scheme"))}://${atob(getUrlParamValue("route"))}`);
    }
    return "unknown";
  }

  return (
    <>
      {/*  <div className="col-sm-8 col-sm-offset-2">
                        {alert.message &&
                            <div className={`alert ${alert.type}`}>{alert.message}</div>
                        }
                        
                        <Router history={history}>
                            <Switch>
                                <Route path="/login" component={SignIn} />
                                <PrivateRoute component={Main} />
                            </Switch>
                        </Router>
                        
                </div> */}
      {/* <SignIn /> */}
      <Router>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route
            exact
            path="/loginwithotp/:username"
            component={LoginWithOTP}
          />
          <Route exact path="/loginwithtotp/:username" component={TOTP} />
          {/* <Route exact path="/setpin" component={SetPin} />
          <Route exact path="/setpin/:step" component={SetPin} />
          <Route exact path="/enterpin" component={EnterPin} /> */}
          <Route path="/forgotpassword/:username" component={ForgotPassword} />
          <Route path="/forgotpassword/" component={ForgotPassword} />
          <Route path="/changepassword/:step" component={ForgotPassword} />

          {/* <Route path="/changepassform" component={ChangepassForm} /> */}
        </Switch>
      </Router>
    </>
  );
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
